<bp-content color="lightgradient" padding class="full-height">
  @if (getWallet()) {
    @if (!isIframeMode) {
      <div class="wallet-details-header pb-0">
        <div class="wallet-details-header__links container-left-right">
          <div>
            <a class="wallet-details-header__links__link" [routerLink]="['/portfolio']">
              <span class="bpi__icon-caret-left"></span>
              <span class="font-size-15 pl-15">
                {{ "portfolio_overview_button_text" | translate }}
              </span>
            </a>
          </div>
        </div>
        <div class="wallet-details-header__masthead">
          <div class="wallet-details-header__masthead__title">
            @if (logosV4Active$ | async) {
              <img class="img-size" [src]="tradable.getLogo()" #img (error)="img.src = tradable.getDefaultLogo()">
            }
            @if ((logosV4Active$ | async) === false) {
              <span
                class="wallet-details-header__masthead__title__currency-symbol"
              [ngClass]="getCssClass()"></span>
            }
            {{ walletName | async }}
            <a (click)="openWalletDetails()" class="wallet-details-header__masthead__title__edit-icon">
              <span class="bpi__icon-edit wallet-details-header__masthead__title__edit-icon__actual"></span>
            </a>
          </div>
          <div class="wallet-details-header__masthead__amount__actual">
            {{
            toFiat(getWallet().getBalance())
            | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat], symbol: true }
            }}
          </div>
        </div>
        <!--ACTION BUTTONS-->
        <asset-mobile-action-button-wrapper
          [buttonActions]="getButtonActions()"
          [wallet]="getWallet()"
        [tradable]="getCurrency()"></asset-mobile-action-button-wrapper>
        <!---->
      </div>
      <!--WALLET HOLDINGS-->
      @if (showIndexChart()) {
        <div class="wallet-details-header mod-index">
          <index-holdings [isWalletHoldings]="true" [tradable]="getCurrency()"></index-holdings>
        </div>
      }
      <!---->
    }
    <div class="wallet-details-header" [ngClass]="{ 'mod-no-top-padding': !showIndexChart() || isIframeMode }">
      <div class="wallet-details-header__filters">
        <span class="font-size-20 font-semibold mb-15 block">{{ "transactions" | translate }}</span>
        <div class="bp-wrapper">
          <a
            class="filter-button btn btn-primary btn-sm"
            [ngClass]="{ 'is-active': noFilter() }"
            (click)="clearFilter()"
            (keydown.enter)="clearFilter()"
            [tabIndex]="0">
            {{ "show_all" | translate }}
          </a>
          @for (buttonAction of getFilters(); track buttonAction) {
            <a
              class="filter-button btn btn-primary btn-sm"
              [ngClass]="{ 'is-active': isType(buttonAction) }"
              (click)="filter(buttonAction)"
              (keydown.enter)="filter(buttonAction)"
              [tabIndex]="0">
              {{ "filter-button-" + buttonAction | translate }}
            </a>
          }
        </div>
      </div>
    </div>
  }

  <!-- PENDING TRADES INFO-->
  @if (pendingTrades$ | async; as pendingTrades) {
    <transaction-pending-ribbon [pendingTrades]="pendingTrades">
    </transaction-pending-ribbon>
  }

  <div class="wallet-details__body center-block">
    @for (keys of map?.keys(); track keys) {
      <div class="transactions-list">
        <div class="transactions-list-separator">
          <span>{{ keys }}</span>
        </div>
        @for (transaction of map?.get(keys); track transaction) {
          <tradable-transaction-list-item
            [transaction]="transaction"
            [focusable]="true"
            class="card-interactive">
          </tradable-transaction-list-item>
        }
      </div>
    }
    @if (map?.size === 0) {
      <empty [headline]="'wallet_detail_no_transactions_made' | translate"></empty>
    }
    <bp-pagination [ngClass]="'pagination-wrapper'"></bp-pagination>
  </div>
</bp-content>
